module.exports = __webpack_public_path__ + "img/undraw_Onboarding_re_6osc.05105201.svg";